import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar/Sidebar';
import { SidebarProvider } from './sidebar/SidebarContext';
import { MobileBottomNav } from './navigation/MobileBottomNav';

export function DashboardLayout() {
  return (
    <SidebarProvider>
      <div className="flex h-screen overflow-hidden bg-surface">
        <Sidebar />
        <main className="flex-1 overflow-y-auto overflow-x-hidden pb-16 md:pb-0">
          <Outlet />
        </main>
        <MobileBottomNav />
      </div>
    </SidebarProvider>
  );
}

export function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-surface overflow-x-hidden">
      <Outlet />
    </div>
  );
}
